import { customFetch } from 'utils/http';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import {
  M8PaginationParams,
  M8PagedResponse,
  M8PaymentTransactionDTO,
  M8PaymentTransactionDTOSortableField,
} from 'services/production/types';
import { HTTPResponseError } from 'utils/errors';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = M8PaginationParams<M8PaymentTransactionDTOSortableField>;

export const getPaymentTransactions = async (
  params: Params
): Promise<null | M8PagedResponse<M8PaymentTransactionDTO>> => {
  const response = await customFetch(
    getM8AdminURL(`getPaymentTransactions?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return null;
};
